function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M4.13805 26.563L3.93679 25.8586C1.61392 17.7285 6.37462 9.26608 14.529 7.03019L17.4282 6.23524C23.0194 4.70219 29.0064 5.92938 33.5435 9.53846L40.2248 14.8531C45.276 18.8711 51.7421 20.6661 58.1417 19.8268L73.5302 17.8086C78.6915 17.1317 82.2297 12.2651 81.2819 7.14661C80.9307 5.2501 82.3864 3.5 84.3152 3.5H111.225C115.434 3.5 119.157 6.23205 120.419 10.2479C121.658 14.1912 120.245 18.4858 116.906 20.9224L110.059 25.9185C106.636 28.4167 104.375 32.1992 103.796 36.3974C103.221 40.5651 100.003 43.8747 95.8534 44.5664L76.1311 47.8534C74.5548 48.1161 72.9523 47.567 71.8684 46.3928C69.1678 43.4672 65.0704 42.2755 61.222 43.2965L48.3404 46.7141C44.2341 47.8035 39.905 47.7229 35.842 46.4815L29.9833 44.6913C25.9201 43.4498 21.521 43.9889 17.8777 46.1748C11.5374 49.979 3.56779 44.9443 4.28001 37.5847L4.7243 32.9937C4.93347 30.8323 4.7346 28.6509 4.13805 26.563Z",
  stroke: "currentColor",
  strokeWidth: 6
});

function SvgCountryside3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 124,
    height: 51,
    viewBox: "0 0 124 51",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCountryside3);
export default __webpack_public_path__ + "static/media/countryside3.203a4563.svg";
export { ForwardRef as ReactComponent };